<template>
  <ModalBase :show-modal="true" @close-modal="close" :short="false" :fullAutoH="false" :auto-h="true" :narrow="true" :overlay-scrollb="false" class="dashboard-modal onboarding-modal">
    <template v-slot:maincontent>
      <div class="slider-wrap">
        <flickity class="onboarding-slider" ref="flickity" :options="flickityOptions" @init="onInit">
          <div v-for="(item, index) in slideItems" :key="'onb-' + index" class="carousel-cell">
            <div class="carousel-cell__media">
              <img v-if="item.image" :src="'/static/public/img/' + item.image" alt="">
              <video v-if="item.media" muted :ref="videoRefSel + '-' + index">
                <source :src="item.media" type="video/mp4">
                Your browser does not support the video tag.
              </video>
            </div>
            <div v-if="(item.title || item.description)" :ref="'cellcontent-' + index" class="carousel-cell__content content-main contentabsolute">
              <h3 class="slide-title" v-html="item.title" />
              <p v-html="item.description" />
            </div>
            <div v-if="(item.posttitle)" :ref="'cellcontent-blank-' + index" class="carousel-cell__content content-blank contentabsolute" />
            <div v-if="(item.posttitle)" :ref="'cellcontent-post-' + index" class="carousel-cell__content content-post contentabsolute">
              <h3 class="slide-title" v-html="item.posttitle" />
            </div>
          </div>
        </flickity>

        <div class="slider-controls">
          <GekkoButton 
            @click="previous()"
            :text="$gettext('Previous')"
            variant="link"
            class="px-0"
            size="sm"
          />
          <GekkoButton 
            @click="next()"
            :text="(letsStart) ? finalStepText : $gettext('Next')"
            size="sm"
          />
        </div>
      </div>  
    </template>
  </ModalBase>
</template>

<script>
import Flickity from 'vue-flickity';
import 'flickity-fade';
import { mapActions, mapGetters } from "vuex";
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton"
export default {
  name: 'onboarding-modal',
  components: {
    ModalBase, TitleBar, Flickity, GekkoButton
  },
  props: {

  },
  data() {
    return {
      customBody: false,
      descriptionItems: null,
      actionItems: null,
      modalContent: {
        pretitle: null,
        title: null,
        body: null,
        actions: null
      },
      videoRefSel: 'videoslide',
      currentSlide: 0,
      currentTimeout: null,
      defaultTitleDelay: 3000,
      defaultGapDelay: 1500,
      flickityOptions: {
        prevNextButtons: false,
        pageDots: true,
        wrapAround: false,
        draggable: false,
        cellAlign: 'center',
        fade: true,
        percentPosition: false,
        adaptiveHeight: true,
        setGallerySize: true
      }
    }
  },
  computed: {
    ...mapGetters ({ 
      slideItems: "onboarding/getModalContent",
      hasTrigger: "onboarding/getModalTrigger",
      isPremiumUser: "getIsPremium" // root getter
    }),
    letsStart () {
      return this.currentSlide === (this.slideItems.length - 1)
    },
    finalStepText () {
      return (this.hasTrigger && !this.isPremiumUser) ? this.$gettext('Upgrade now') : this.$gettext('Got it')
    }
  },
  beforeDestroy () {
    clearTimeout(this.currentTimeout)
  },
  methods: {
    ...mapActions ({
      dismissOnboarding: "onboarding/dismissOnboarding"
    }),
    isString(value) {
      return typeof value === 'string' || value instanceof String;
    },
    close () {
      this.dismissOnboarding()
    },
    next () {
      clearTimeout(this.currentTimeout)
      if (this.letsStart) {
        if (this.hasTrigger && !this.isPremiumUser) {
          window.location.href = '/subscriptions/manage'
        }
        this.dismissOnboarding()
      } else {
        this.$refs.flickity.next();
      }
    },
    previous () {
      clearTimeout(this.currentTimeout)
      this.$refs.flickity.previous();
    },
    onInit () {
      // on init play first video (if any)
      this.playTextVideo(this.currentSlide)
      
      // change event listener
      this.$refs.flickity.on('change', (index) => {
        const previousSlide = this.currentSlide
        this.currentSlide = index
        this.stopVideo(previousSlide)
        this.playTextVideo(this.currentSlide)
      })
    },
    playTextVideo (index) {
      if (this.slideItems[index].title || this.slideItems[index].description) {
        
        if (this.slideItems[index].posttitle) {
          if (this.$refs['cellcontent-blank-' + index][0]) this.$refs['cellcontent-blank-' + index][0].classList.add('hidden')
          if (this.$refs['cellcontent-post-' + index][0]) this.$refs['cellcontent-post-' + index][0].classList.add('hidden')
        }
        this.$refs['cellcontent-' + index][0].classList.remove('hidden')

        clearTimeout(this.currentTimeout)

        this.currentTimeout = setTimeout(() => {
          if (this.$refs['cellcontent-' + index]) this.$refs['cellcontent-' + index][0].classList.add('hidden')
          this.playVideo(index)
        }, (this.slideItems[index].titledelay) ? this.slideItems[index].titledelay : this.defaultTitleDelay)

      } else {
        this.playVideo(index)
      }
    },
    playVideo (index) {
      if (this.slideItems[index].media) {
        const videoEl = this.$refs[this.videoRefSel + '-' + index][0]
        videoEl.play()
        if (videoEl.getAttribute('listener') !== 'true') {
          videoEl.addEventListener('ended', () => { this.playPostTitle(index) })
          videoEl.setAttribute('listener', 'true')
        }
      }
    },
    playPostTitle (index) {
      if (this.slideItems[index].posttitle) {
        if (this.$refs['cellcontent-post-' + index]) this.$refs['cellcontent-post-' + index][0].classList.remove('hidden')

        clearTimeout(this.currentTimeout)

        this.currentTimeout = setTimeout(() => {

          if (this.$refs['cellcontent-post-' + index]) this.$refs['cellcontent-post-' + index][0].classList.add('hidden')
          if (this.$refs['cellcontent-blank-' + index]) this.$refs['cellcontent-blank-' + index][0].classList.remove('hidden')

          setTimeout(() => {
            this.playTextVideo(index)
          }, (this.slideItems[index].gapdelay) ? this.slideItems[index].gapdelay : this.defaultGapDelay)
          
        }, (this.slideItems[index].posttitledelay) ? this.slideItems[index].posttitledelay : this.defaultTitleDelay)
      } else {
        this.playTextVideo(index)
      }
    },
    stopVideo (index) {
      if (this.slideItems[index].media && this.$refs[this.videoRefSel + '-' + index]) {
        const videoEl = this.$refs[this.videoRefSel + '-' + index][0]
        videoEl.removeEventListener('ended', () => { this.playPostTitle(index) })
        videoEl.setAttribute('listener', 'false')
        videoEl.pause()
        videoEl.currentTime = 0
      }
    }
  }
}
</script>

<style lang="scss">
  .onboarding-modal.dbug {
    * { outline: 1px solid red; }
    .modal-content-wrap {
      background: blue;
      .onboarding-slider {
        background: red;
        .flickity-viewport {
          background: aqua;
        }
        .carousel-cell {
          background: purple;
          &__content {
            background: lime;
          }
        }
      }
      .slider-controls {
        background: pink;
      }
    }
  }
  .onboarding-modal {
    $mediaHeight: 310px;
    .gk-modal-backdrop { background: rgba(0, 0, 0, 0.5); }
    .gk-modal { overflow: hidden !important; }
    .modal-content-wrap {
      margin: 0 !important;
      flex: initial !important;
      border-radius: 0 !important;
      background: white;
      .slider-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;
      }
      .onboarding-slider {
        height: 100%;
      }

      .flickity-viewport {
        transition: height 0.2s;
        min-height: $mediaHeight;
      }
      .carousel-cell {
        width: 100%;
        &__media {
          width: 100%;
          height: $mediaHeight;
          video,
          img { 
            width: 100%;
            height: 100%;
            object-fit: contain;
            display: block;
          }
        }
        &__content {
          width: 100%;
          color: $colorTextBase;
          text-align: center;
          padding-top: 15px;
          .slide-title {
            display: flex; width: 100%;
            align-items: center;
            justify-content: center;
            line-height: 1.25;
            font-size: 28px; 
            .widget-premium-badge { margin: 0 !important; margin-right: 5px !important; }
          }
          p {
            font-size: 18px;
            color: #adadad;
            margin: 0;
          }
          &.contentabsolute {
            position: absolute;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: white;
            opacity: 1;
            &.content-post {
              transition: opacity 0.2s;
            }
            &.hidden {
              transition: opacity 0.2s;
              opacity: 0;
            }
          }
        }
      }
      .flickity-page-dots {
        bottom: -40px;
        width: auto;
        left: 50%;
        transform: translateX(-50%);
        .dot {
          background: $colorBrand;
          margin: 0 6px;
          width: 8px;
          height: 8px;
        }
      }
      .slider-controls {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding-top: 15px;
        button { padding: 3px 20px; }
        a { font-size: 14px; }
      }
    }
  }
</style>
